import { AuthService } from './business/auth.service';
import { AfterViewInit, Component, Inject } from '@angular/core';
import { NavigationCancel, NavigationEnd, Router } from '@angular/router';
import { Meta } from '@angular/platform-browser';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { environment } from 'src/environments/environment';
import { DownloadsService } from './business/download/downloads.service';
import { DOCUMENT } from '@angular/common';
import { InfoliniaModalComponent } from './business/infolinia-modal/infolinia-modal.component';
import { NgxSmartModalService } from 'ngx-smart-modal';
import * as moment from 'moment';
import { OneTrustService } from './_services/one-trust.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements AfterViewInit {
  constructor(
    private router: Router,
    private gtmService: GoogleTagManagerService,
    private _meta: Meta,
    private readonly authService: AuthService,
    private readonly downloadsService: DownloadsService,
    @Inject(DOCUMENT) private document: Document,
    public ngxSmartModalService: NgxSmartModalService,
    private readonly _oneTrustService: OneTrustService
  ) {
    this.document.body.onclick = (e) => {
      let element;
      element = e.target;
      if (
        element &&
        element.className &&
        typeof element.className == 'string' &&
        element.className.indexOf('booksy-widget-overlay') !== -1
      ) {
        const booksy_overlay = document.querySelector('.booksy-widget-overlay');
        const booksy_widget = document.querySelector('.booksy-widget-dialog');
        booksy_overlay.remove();
        booksy_widget.remove();
      }
    };

    this.authService.me$.subscribe((me) => {
      if (me) {
        this.downloadsService.getItems(me.type);
      }
    });

    this.router.events.forEach((item) => {

      if (item instanceof NavigationEnd) {

        // Redirect to biznes side
        if(item.url.indexOf("/ankieta/") > -1) {
          window.location.href=`${environment.path}/biznes${item.url}`;
        }
        //End redirect

        const gtmTag = {
          event: 'page',
          pageName: item.url,
        };
        if (environment.ga) {
          this.gtmService.pushTag(gtmTag);
        }

        const root = environment.path;

        this._meta.updateTag({
          property: 'og:url',
          content: `${root}${item.url}`,
        });
        this._meta.updateTag({
          property: 'og:image:type',
          content: 'image/jpeg',
        });

        if (item.url === '/' || item.url === '') {
          this._meta.updateTag({
            property: 'og:image',
            content: `${root}/assets/og_image/1.webp`,
            itemprop: 'image',
          });
        } else if (item.url.includes('/artykuly')) {
          this._meta.updateTag({
            property: 'og:image',
            content: `${root}/assets/og_image/2.webp`,
            itemprop: 'image',
          });
          // } else if (item.url.includes('/aktualnosci')) {
          //   this._meta.updateTag({
          //     property: 'og:image',
          //     content: `${root}/assets/og_image/6.webp`,
          //     itemprop: 'image',
          //   });
        } else if (item.url.includes('/salon-expert-tv')) {
          this._meta.updateTag({
            property: 'og:image',
            content: `${root}/assets/og_image/3.webp`,
            itemprop: 'image',
          });
          // } else if (item.url.includes('/lookbook-2019')) {
          //   this._meta.updateTag({ property: 'og:image', content: `${root}/assets/og_image/1.webp`, itemprop: 'image' });
        } else if (item.url.includes('/zmiana-koloru')) {
          this._meta.updateTag({
            property: 'og:image',
            content: `${root}/assets/og_image/5.webp`,
            itemprop: 'image',
          });
        } else if (item.url.includes('/produkt')) {
          this._meta.updateTag({
            property: 'og:image',
            content: `${root}/assets/og_image/4.webp`,
            itemprop: 'image',
          });
        } else if (item.url.includes('/efekty')) {
          this._meta.updateTag({
            property: 'og:image',
            content: `${root}/assets/og_image/4.webp`,
            itemprop: 'image',
          });
        } else if (item.url.includes('/gamy')) {
          this._meta.updateTag({
            property: 'og:image',
            content: `${root}/assets/og_image/4.webp`,
            itemprop: 'image',
          });
        } else if (item.url.includes('/salon')) {
          this._meta.updateTag({
            property: 'og:image',
            content: `${root}/assets/og_image/4.webp`,
            itemprop: 'image',
          });
        } else if (item.url.includes('/kontakt')) {
          this._meta.updateTag({
            property: 'og:image',
            content: `${root}/assets/og_image/8.webp`,
            itemprop: 'image',
          });
        } else if (item.url.includes('/zapisyszkoleniaonline')) {
          this._meta.updateTag({
            property: 'og:image',
            content: `${root}/assets/og_image/zapisyszkoleniaonline.webp`,
            itemprop: 'image',
          });
        } else {
          this._meta.updateTag({
            property: 'og:image',
            content: `${root}/assets/og_image/1.webp`,
            itemprop: 'image',
          });
        }
      }
    });
  }

  ngAfterViewInit() {
    this.startsModals();
    if (environment.production) this._oneTrustService.addScriptToDom().then();
  }

  async startsModals() {
    if (moment(new Date()).isBefore(moment('2022-06-20 00:00:00'), 'day')) {
      await this.infoliniaModal();
    }
  }

  infoliniaModal() {
    return new Promise((resolve) => {
      const modal = this.ngxSmartModalService
        .create('infolinia', InfoliniaModalComponent, {
          customClass: 'centerModal',
        })
        .open();
      modal.onClose.subscribe(() => {
        resolve('show infolinia info');
      });
    });
  }
}
